import { render, staticRenderFns } from "./emailVerified_page.vue?vue&type=template&id=4ff672fa&scoped=true&"
import script from "./emailVerified_page.vue?vue&type=script&lang=js&"
export * from "./emailVerified_page.vue?vue&type=script&lang=js&"
import style0 from "./emailVerified_page.vue?vue&type=style&index=0&id=4ff672fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff672fa",
  null
  
)

export default component.exports